@if (!isPageReady) {
<div class="spur-page-loader" role="status" aria-live="polite" aria-busy="true">
    <div class="spur-page-loader__inner">
        <div class="spur-page-loader__visual" aria-hidden="true">
            <span class="spur-page-loader__orbit"></span>
            <span class="spur-page-loader__mark"></span>
        </div>
        <p class="spur-page-loader__brand">Spur Experiences</p>
        <p class="spur-page-loader__line">Loading charity…</p>
    </div>
</div>
} @else if (pageNotFound) {
<app-not-found [isNotFound]="true"></app-not-found>
} @else {
<div class="loader" *ngIf="loading">
    <div class="loaderImg"><img src="./assets/images/loading.gif" alt="" /></div>
</div>
<section>
    <div class="container-fluid " *ngIf="charity_detail_data">
        <div class="row registeryParent parentLoading lazyload"
            [attr.data-bg]="charity_detail_data.cover_image ? profile_url+charity_detail_data.cover_image : '../../../../assets/images/option_img.png' "
            style="background-image:url('assets/images/largeloading.gif')">
            <div class="col-12 px-0 h-100">
                <h1 class="comName">{{charity_detail_data?.title}}
                    <p class="webName"><span>{{charity_detail_data?.website}}</span></p>
                </h1>

                <div class="profileImg">
                    <figure>
                        <img class="lazyload"
                            [attr.data-src]="charity_detail_data.profile_image ? profile_url+charity_detail_data.profile_image : 'assets/images/option_img.png'"
                            src="assets/images/loading.gif" alt="" />
                    </figure>
                </div>
                <div class="col-12 px-0">

                </div>

            </div>
            <div class="ticket_reg">
                <a *ngIf="!authUser" class="primary-btn" routerLink="/registration/wedding-couple">CREATE A REGISTRY</a>
                <a class="primary-btn" routerLink="/find-couple">FIND A REGISTRY</a>
            </div>

        </div>
    </div>
    <div class="col-12 magniPopHead" *ngIf="charity_detail_data?.video_update">
        <div class="text-center">
            <a class="btn Play video magni-pop" (click)="videoPopup(charity_detail_data?.video_update)"
                href="javascript:void(0);">
                <span class="videoCameraIcon"></span>
                <em>Charity Preview</em>
            </a>
        </div>
    </div>

    <!-- ----------------- return to search btn  -->



    <div class="productReview">
        <div class="container">
            <div class="productInfo">
                <div class="row">
                    <div class="col-12 charityDetailOwl col-sm-10 m-auto col-md-5 col-lg-4">
                        <!-- <owl-carousel [options]="owlCharityDetail">
						   <div class="item " *ngIf="charity_detail_data">
                                <img class="lazyload" [attr.data-src]="charity_detail_data.image ? charity_detail_url+charity_detail_data.image : 'assets/images/option_img.png'" alt="" src="assets/images/loading.gif">
								<div style="text-align: center;" class="selectedMsg" *ngIf="authUser?.charity_choosed==charity_detail_data.id">selected</div>
                            </div>
                          
                        </owl-carousel> -->

                        <div class="productInfo_owl position-relative">

                            <owl-carousel-o [options]="owlExpDetail">
                                <ng-template carouselSlide [id]="charity_detail_data?.id">
                                    <div class="item">

                                        <!-- <div class="productOwlBackImg" [attr.data-bg]="charity_detail_data.image_url" style="background-image:url(assets/images/loading.gif)">
                                            <img class="lazyload" [attr.data-src]="charity_detail_data.image_url" alt=""
                                            src="assets/images/loading.gif">
                                        </div> -->


                                        <img class="lazyload" [attr.data-src]="charity_detail_data?.image_url" alt=""
                                            [attr.src]="charity_detail_data?.image_url">


                                        <!-- <img class="lazyload" [attr.data-src]="featuredImage ? featuredImage : 'assets/images/option_img.png'" alt=""
                                            src="../../../../assets/images/loading.gif"> -->

                                    </div>
                                </ng-template>
                            </owl-carousel-o>

                        </div>
                    </div>
                    <div class="col-12 charityDetailInfo col-md-7 col-lg-8">
                        <div class="productDes">
                            <h5><span>{{charity_detail_data?.title}}</span></h5>
                            <div class="aboutLink">
                                <a [href]="getWebsiteUrl(charity_detail_data?.website)"
                                target="_blank"
                                rel="noopener noreferrer">
                               {{ charity_detail_data?.website }}
                             </a>
                            </div>
                            <div class="aboutLink">
                                <a href="javascript:void(0)">{{charity_detail_data?.phone_number}}</a> &nbsp;
                                {{charity_detail_data?.email ? '|' : ''}} &nbsp; <a
                                    href="javascript:void(0);">{{charity_detail_data?.email}}</a>
                            </div>
                            <div *ngIf="isLoggedIn && authUser?.role_id == 1" class="buyadd_btns">
                                <button class="btn btnadd" data-dismiss="modal" aria-label="Close"
                                    *ngIf="authUser?.charity_choosed!=charity_detail_data?.id"
                                    (click)="charitySelection(charity_detail_data?.id)">choose charity </button>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="productTabInfo">
        <div class="container">
            <div class="no-gutters exps-tab mt-4">
                <div class="tabs-block">
                    <div>
                        <a class="exp-tabs-item" [ngClass]="(selectedTab==0) ? 'active' : ' '" (click)="tab_change(0)"
                            href="javascript:void(0);">SUMMARY</a>
                    </div>
                    <div>
                        <a class="exp-tabs-item" [ngClass]="(selectedTab==1) ? 'active' : ' '" href="javascript:void(0)"
                            (click)="tab_change(1)">DETAILS</a>
                    </div>
                    <div>
                        <a class="exp-tabs-item" [ngClass]="(selectedTab==2) ? 'active' : ' '" href="javascript:void(0)"
                            (click)="tab_change(2)">LOCATION</a>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="tab-content" id="myTabContent" *ngIf="charity_detail_data">
                        @if (selectedTab == 1) {
                        <div class="summaryDetailTab">
                            <div class="container">
                                <div class="row">
                                    <div class="col-12 px-0">
                                        <h2 class="subHeadings">{{'Details'}}:</h2>
                                        <div class="headingParent">
                                            <p [innerHTML]="charity_detail_data.details | appendDollar"></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        } @else if (selectedTab == 2) {
                        <div class="summaryDetailTab">
                            <div class="container">
                                <div class="row">
                                    <div class="col-12 px-0">
                                        <h2 class="subHeadings">{{'Location'}}:</h2>
                                        <div class="headingParent">
                                            <!-- <h2>THE EXPERIENCE</h2> -->
                                            <p [innerHTML]="charity_detail_data.location"></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        } @else {
                        <div class="summaryDetailTab">
                            <div class="container">
                                <div class="row">
                                    <div class="col-12 px-0">
                                        <h2 class="subHeadings">{{charity_detail_data.title + ' Summary' |
                                            titlecase}}:</h2>
                                        <div class="headingParent">
                                            <p [innerHTML]="charity_detail_data.summary"></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        }

                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- *****************  new letter box ********************* -->

    <div class="modal fade pr-0" id="Cartmodal_1">
        <div class="modal-dialog mx-auto modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header border-bottom-0 modaltheme_head">
                    <h5 class="modal-title ">NAME TO APPEAR ON VOUCHER <br> <span>ID will be checked at time of
                            redemption</span></h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="popupBody">
                        <form>
                            <div class="form-group mb-0">
                                <input type="text" placeholder="first Name" class="form-control" />
                            </div>
                            <div class="form-group mb-0">
                                <input type="text" placeholder="Last Name" class="form-control" />
                            </div>
                            <button type="submit" class="modalCarbtn">Add to cart</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>

</section>

<!-- Custom Magnific Popup -->


<div class="modal fade  videoPopupModal" id="videoPopupModal" bsModal #videoPopupModal="bs-modal" tabindex="-1"
    role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content theme-modal">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="videoPopupModal.hide()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body " *ngIf="charity_detail_data">
                <div *ngIf="charity_detail_data.video_type == '' || charity_detail_data.video_type == 'file_upload'">
                    <video width="100%" controls id="videoToPlay">
                        <source [src]="charity_detail_data.video_update2+'.mp4'" type="video/mp4">
                        <source [src]="charity_detail_data.video_update2+'.webm'" type="video/webm">
                    </video>
                </div>
                <div *ngIf="charity_detail_data.video_type == 'youtube'">
                    <iframe [src]="charity_video_url" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe>
                </div>
            </div>
        </div>
    </div>
</div>
}